export const nearbyData = [
  {
    id: 1,
    title: '합덕제',
    description:
      "합덕제는 조선 3대 저수지 중의 하나로, '세계 관개시설물 유산'으로 등재되었습니다.",
    latitude: 36.79043667866844,
    longitude: 126.7892116646178,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_03_01/view.do?cntno=126',
  },
  {
    id: 2,
    title: '버그내순례길',
    description: '천주교 순교의 발자취를 따라 당진 버그내 순례길을 걷다.',
    latitude: 36.786061035924895,
    longitude: 126.75915440208826,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_02_01/view.do?cntno=89',
  },
  {
    id: 3,
    title: '솔뫼성지',
    description:
      '한국 최초의 사제 김대건 신부가 태어난 곳으로 그의 생가와 기념관이 함께 마련되어 있는 작은 마을이다.',
    latitude: 36.82045606041359,
    longitude: 126.78606953959861,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_02_02/view.do?cntno=84',
  },
  {
    id: 4,
    title: '신리성지',
    description: '천주교 탄압의 역사가 깃들어 있는 조선의 카타콤바',
    latitude: 36.76268490506753,
    longitude: 126.77108804601113,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_02_03/view.do?cntno=91',
  },
  {
    id: 5,
    title: '합덕성당',
    description:
      '역사적, 건축적, 예술적 가치를 품은 충남에서 가장 오래된 성당, 합덕성당',
    latitude: 36.792899205567224,
    longitude: 126.78556357085189,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_02_04/view.do?cntno=124',
  },
  {
    id: 6,
    title: '기지시줄다리기박물관',
    description:
      '당진시 송악읍 기지시 줄다리기를 비롯하여 국내외 줄다리기 관련 자료 및 각종 체험시설을 갖추고 있는 곳',
    latitude: 36.89619239513826,
    longitude: 126.6947358778407,
    link: 'https://www.dangjin.go.kr/prog/tursmCn/tour/sub02_02_07/view.do?cntno=86',
  },
  {
    id: 7,
    latitude: 36.890694548894864,
    longitude: 126.82443143238886,
  },
];
